import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5623dcad&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5623dcad')) {
      api.createRecord('5623dcad', component.options)
    } else {
      api.reload('5623dcad', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5623dcad&", function () {
      api.rerender('5623dcad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suppliers_portal/captain_working_summaries/index.vue"
export default component.exports